import { List } from 'immutable';

/**
 * One energy type per energy the attachments provide, so a Double Colorless (count 2) gives two. The type is what
 * the server says each provides right now: a Fire Energy's own type, Fire for any energy on Charizard after Energy
 * Burn, the type picked for a Buzzapped Electrode. The board, the energy list and the retreat check all count
 * energy this way, as the server's cost checks do.
 *
 * @param {List} energyAttachments
 * @returns {List<string>}
 */
export function energySymbols(energyAttachments) {
  return (energyAttachments || List()).flatMap(attachment => {
    const type = attachment.get('provides');
    const count = attachment.get('count') || 1;
    return List(Array.from({ length: count }, () => type));
  });
}
